//DATA
export const RELATION_TYPE_SAVED = 'RELATION_TYPE_SAVED';
export const EDIT_RELATION_TYPE = 'EDIT_RELATION_TYPE';
export const RELATION_TYPE_DELETED = 'RELATION_TYPE_DELETED';
export const SET_RELATION_TYPES = 'SET_RELATION_TYPES';
export const RESET_RELATION_TYPE = 'RESET_RELATION_TYPE';